module.exports = __webpack_public_path__ + "static/media/Sugar Cube.4b4afe51.png";